/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2018, Zumper
 * @description capitalize
 */

/**
 * Capitalize a word
 *
 * @param word
 */
export const capitalize = <T extends string>(word: T): Capitalize<T> => {
  if (!word?.length) {
    // @ts-expect-error TS can't tell we capitalized correctly
    return ''
  }
  // @ts-expect-error TS can't tell we capitalized correctly
  return word[0].toUpperCase() + word.substring(1)
}
